import { Vertical } from '$lib/def/verticals';
import type { ParamMatcher } from '@sveltejs/kit';
 
export const match: ParamMatcher = (param) => {
	return param === Vertical.Restaurant || param === Vertical.Store || param === Vertical.Grocery;
}